<template>
  <div><Calendar :sessions="sessions" /></div>
</template>

<script>
import Calendar from "@/components/Calendar.vue";
import { db } from "@/services/firebaseServices.js";
export default {
  data() {
    return {
      sessions: {}
    };
  },
  components: {
    Calendar
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  created() {
    this.userSessions();
  },
  methods: {
    userSessions() {
      db.collection("sessions")
        .doc(this.userId)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.sessions = doc.data().sessions;
          }
        });
    }
  }
};
</script>

<style>
</style>